import React, { Fragment } from 'react';
import TextField from 'src/ui/library/TextField';
import Autocomplete from 'src/ui/library/Autocomplete';
import TextArea from 'src/ui/library/TextArea';
import customTextMask from './customTextMask';
import InfoTooltip from 'src/ui/library/ToolTip/InfoTooltip';
import DOMPurify from 'dompurify';
import intl from 'react-intl-universal';
import iconTransform from 'src/helpers/iconTransform.js';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';
import ErrorIcon from '@material-ui/icons/Error';

const renderCustomTextControl = props => {
  const {
    multiline,
    mask,
    hasError,
    readOnly,
    helpText,
    smartLookUpSearchable,
    smartAddLookupName,
    onChange,
    label,
    value,
    elementActions,
  } = props;
  const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');
  const { getParserState, setExactInput } = elementActions();

  const maskProps = mask
    ? {
        InputProps: {
          inputComponent: customTextMask,
          placeholder: mask,
        },
      }
    : {};
  let defultValue = {};
  if (!value) {
    defultValue = null;
  } else {
    defultValue[smartAddLookupName] = value;
  }

  const onFilter = (row, val) => {
    return true;
  };

  const onSearch = async input => {
    let { countrySelected, exactInput } = getParserState();
    input = input.trim();
    if (!input) {
      return Promise.resolve({ options: [] });
    }

    let params = { query: input };
    if (countrySelected !== '') {
      params['countryAb'] = countrySelected;
    }

    let resp = await axiosRequest('get', serviceUrls.ADDRESS_LOOKUP, params, null, null, {}, true);
    let noResultFoundObj = {
      AddLine1: exactInput,
      AddLine2: null,
      City: null,
      Country: null,
      County: null,
      PostalCode: null,
      State: null,
      countryCode: null,
      smartLookUp: exactInput,
    };
    if (resp.addressList === null) {
      resp.addressList = [];
    }
    resp.addressList.unshift(noResultFoundObj);

    return { options: resp.addressList };
  };

  if (multiline && multiline === true) {
    return <TextArea {...props} disabled={readOnly ? true : false} style={{ 'text-align': 'initial', 'max-width': '300px', 'min-width': '300px' }} />;
  }

  if (smartLookUpSearchable && smartLookUpSearchable === true) {
    return (
      <div>
        <Autocomplete
          label={label}
          valueKey={smartAddLookupName}
          labelKey={smartAddLookupName}
          defaultValue={defultValue}
          multi={false}
          hideIconOnSelect={true}
          styleType={'AddressLookUP'}
          noResultsText={intl.get('contentparser.noResults')}
          onChange={(valObj, allReleatedValue) => {
            if (valObj === null) {
              valObj = {};
              valObj[smartAddLookupName] = '';
              // Hardcoded object when user remove autoselect
              allReleatedValue = {
                AddLine1: '',
                AddLine2: '',
                County: '',
                PostalCode: '',
                City: '',
                State: '',
                CountryCode: '',
                Country: '',
                SmartLookUp: '',
              };
            }
            let valueSelected = valObj[smartAddLookupName];

            let syntaticEvent = {
              target: {
                value: valueSelected,
              },
            };
            onChange(syntaticEvent, allReleatedValue);
          }}
          onFilter={onFilter}
          loadOptions={onSearch}
          required={props.required}
          setExactInput={setExactInput}
        />
      </div>
    );
  }

  return (
    <Fragment>
      <TextField
        {...props}
        {...maskProps}
        useEllipsisLabel={true}
        ellipsisAdjustIcon={false}
        disabled={readOnly ? true : false}
        hasError={hasError}
        errorText={!helpText ? errorText : null}
      />
    </Fragment>
  );
};

export default props => {
  const { helpText, align, hasParentTable, showText, description, icon, ...otherProps } = props;
  const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');
  const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';
  let finalText = '';
  finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName], otherProps.increaseFontSize);
  finalText = showText === true ? finalText : '';

  return (
    <Fragment>
      <div className={`control-text flex-column ${alignClass}`}>
        {finalText && !hasParentTable ? (
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}></div>}
            <div className={'control-icons-inline-controls label-field'}>
              <span component="legend" className="control-label">
                {finalText}
              </span>
            </div>
          </div>
        ) : null}
        {
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
            <div className={`control-icons-inline-controls ${helpText ? 'with-tooltip' : ''} ${icon ? 'with-icon' : ''}`}>
              {helpText ? (
                <Fragment>
                  <InfoTooltip
                    toolTipText={helpText}
                    labelText={renderCustomTextControl(props)}
                    className="custom-text-tooltip"
                    labelClassName="custom-text-tooltip-label"
                  />
                  {props.hasError && (
                    <p className="textfield-error-text"> <ErrorIcon sx={{ verticalAlign:'bottom', fontSize: 14 }}/> <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorText) }} /></p>
                  )}
                </Fragment>
              ) : (
                renderCustomTextControl(props)
              )}
            </div>
          </div>
        }
      </div>
    </Fragment>
  );
};
